import { createSlice, createAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { IWebhook } from 'shared/interfaces/webhook.interface';
import { initialStore } from '../initial-store';

// Actions
export const deleteWebhook = createAction(
  'webhooks/DELETE_WEBHOOK',
  (payload) => ({ payload })
);
export const getDictionaryWebhooksEventTypes = createAction(
  'webhooks/GET_DICTIONARY_WEBHHOOK_EVENT_TYPES'
);
export const createWebhookData = createAction(
  'webhooks/CREATE_WEBHOOK',
  (payload) => ({
    payload
  })
);
export const updateWebhookData = createAction(
  'webhooks/UPDATE_WEBHOOK',
  (payload) => ({
    payload
  })
);

const webhooksSlice = createSlice({
  name: 'webhooks',
  initialState: initialStore.webhooks,
  reducers: {
    getWebhooks: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setWebhooks: (state, { payload }) => {
      state.isLoading = false;
      state.webhooks = payload.webhooks;
    },

    removeWebhook: (state, { payload }) => {
      if (state.webhooks) {
        state.webhooks = state.webhooks.filter(
          (webhook: { id: string }) => webhook.id !== payload
        );
      }
      state.isLoading = false;
    },
    getWebhooksEventTypes: (state, { payload }) => {
      state.webhooksEvents = payload;
      state.isLoading = false;
    },
    createNewWebhook: (state, { payload }) => {
      (state.webhooks as IWebhook[]) = [payload, ...state.webhooks];
    },
    updateWebhookSuccess: (state, { payload }) => {
      const webhookIndex = state.webhooks.findIndex(
        ({ id }) => id === payload.id
      );

      const webhooks = state.webhooks as IWebhook[];
      webhooks[webhookIndex] = payload;
      state.isLoading = false;
    }
  }
});
export const {
  removeWebhook,
  getWebhooks,
  setWebhooks,
  getWebhooksEventTypes,
  createNewWebhook,
  updateWebhookSuccess
} = webhooksSlice.actions;

export const { reducer } = webhooksSlice;

// Selectors
export const getWebhooksLoadingSelector = (state: IState) =>
  state && state.webhooks.isLoading;

export const getWebhooksSelector = (state: IState) =>
  state && state.webhooks.webhooks;

export const getAllWebhooksEventTypes = (state: IState) =>
  state && state.webhooks.webhooksEvents;
